module.exports = "/_next/static/images/oilGasPetroleum-506fe6db4c6c11edcfbac8ecd0d72a3d.webp";